angular.module('core')
  .service('bulkUploadApi', ['$filter', 'cancelableResourceFactory', function ($filter, $cancelableResourceFactory) {
    var self = this;
    var bulkUploadUrl = '/u/district/:id/bulkupload';
    var BulkClassrooms = $cancelableResourceFactory.createCacheableResource(null, bulkUploadUrl, {id: '@id'}, {
      upload: {
        url: bulkUploadUrl,
        method: 'POST',
        headers: {'Content-Type': undefined}, // Set content type to undefined to allow browser to specify multipart boundary parameter
        transformRequest: angular.identity    // Leave the upload file data intact
      }
    });

    /**************************************************************/
    /*                          Api                               */
    /**************************************************************/

    self.upload = function(did, file, success, error) {
      var fd = new FormData();
      fd.append('file', file);
      var bulkUpload = BulkClassrooms.upload({id: did}, fd);

      bulkUpload.$promise.then(success).catch(error);

      return bulkUpload;
    };
  }]);
